/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Feature_Reduced_CommissionInputs */

const en_pricing_feature_reduced_commission = /** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Platform Fee`)
};

const es_pricing_feature_reduced_commission = /** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% de Tarifa de Plataforma`)
};

const fr_pricing_feature_reduced_commission = /** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frais de plateforme de ${i?.fee} %`)
};

const de_pricing_feature_reduced_commission = /** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Plattformgebühr`)
};

const id_pricing_feature_reduced_commission = /** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Biaya Platform ${i?.fee}%`)
};

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const ja_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const zh_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const ar_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const it_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const ru_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const pt_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/** @type {(inputs: Pricing_Feature_Reduced_CommissionInputs) => LocalizedString} */
const ko_pricing_feature_reduced_commission = en_pricing_feature_reduced_commission;

/**
* | output |
* | --- |
* | "{fee}% Platform Fee" |
*
* @param {Pricing_Feature_Reduced_CommissionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_reduced_commission = /** @type {((inputs: Pricing_Feature_Reduced_CommissionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Reduced_CommissionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_reduced_commission(inputs)
	if (locale === "es") return es_pricing_feature_reduced_commission(inputs)
	if (locale === "fr") return fr_pricing_feature_reduced_commission(inputs)
	if (locale === "de") return de_pricing_feature_reduced_commission(inputs)
	if (locale === "ja") return ja_pricing_feature_reduced_commission(inputs)
	if (locale === "zh") return zh_pricing_feature_reduced_commission(inputs)
	if (locale === "ar") return ar_pricing_feature_reduced_commission(inputs)
	if (locale === "id") return id_pricing_feature_reduced_commission(inputs)
	if (locale === "it") return it_pricing_feature_reduced_commission(inputs)
	if (locale === "ru") return ru_pricing_feature_reduced_commission(inputs)
	if (locale === "pt") return pt_pricing_feature_reduced_commission(inputs)
	return ko_pricing_feature_reduced_commission(inputs)
});